/* eslint-disable */
export default {
    cp_teams_navbar_title: "Teams",
    cp_teams_navbar_search_placeholder: "Search teams",
    cp_teams_general_error: "An error occurred while processing your request.",
    cp_teams_sidebar_title: "Organisations",
    cp_teams_sidebar_search_placeholder: "Search organisations",
    cp_teams_team_card_manager: "Manager",
    cp_teams_team_card_type_team: "Team",
    cp_teams_team_card_teammembers: "Team members",
    cp_teams_footer_page: "Page",
    cp_teams_no_teams: "No teams found",
    cp_teams_team_card_no_teammembers: "No team members",
    cp_teams_sidebar_empty_organisation: "No organisation found.",
    cp_teams_footer_save_button: "",
    cp_teams_footer_status_saved: "",
    cp_teams_footer_status_unsaved: "",
    cp_teams_navbar_back_button: "",
    cp_teams_form_section_team_title: "",
    cp_teams_form_section_team_description: "",
    cp_teams_form_section_team_members_title: "",
    cp_teams_form_section_team_members_description: "",
    cp_teams_form_section_team_field_name_label: "",
    cp_teams_form_section_team_members_field_search_placeholder: "",
    cp_teams_form_section_team_members_field_search_no_results: "",
    cp_teams_form_section_team_members_button_add: "",
    cp_teams_form_saved: "",
    cp_teams_generic_error: "",
    cp_teams_create_new_team_button_label: "",
    cp_teams_team_created_successfully_message: "",
    cp_teams_new_team_modal_title: "",
    cp_teams_new_team_modal_subtitle: "",
    cp_teams_new_team_modal_organisation_setting_title: "",
    cp_teams_new_team_modal_organisation_setting_description: "",
    cp_teams_new_team_modal_name_setting_title: "",
    cp_teams_new_team_modal_name_setting_description: "",
    cp_teams_new_team_modal_variant_setting_description: "",
    cp_teams_new_team_modal_variant_setting_title: "",
    cp_teams_advisory_team_title: "",
    cp_teams_advisory_team_description: "",
    cp_teams_creative_team_title: "",
    cp_teams_creative_team_description: "",
    cp_teams_management_team_title: "",
    cp_teams_management_team_description: "",
    cp_teams_operational_team_title: "",
    cp_teams_operational_team_description: "",
    cp_teams_project_team_title: "",
    cp_teams_project_team_description: "",
    cp_teams_service_team_title: "",
    cp_teams_service_team_description: "",
    cp_teams_unknown_team_description: "",
    cp_teams_unknown_team_title: "",
    cp_teams_empty_report_title: "",
    cp_teams_empty_report_text: "",
    cp_teams_role_applicant: "Applicant",
    cp_teams_role_member: "Team Member",
    cp_teams_role_manager: "Team Manager",
    cp_teams_add_team_member_modal_field_participant_label: "Participant",
    cp_teams_add_team_member_modal_field_participant_placeholder: "Select participant",
    cp_teams_add_team_member_modal_field_role_label: "Role",
    cp_teams_add_team_member_modal_field_role_placeholder: "Select role",
    cp_teams_add_team_member_modal_title: "Add a new team member",
    cp_teams_add_team_member_modal_subtitle: "Who do you want to add to this team?",
    cp_teams_add_team_member_modal_field_participant_error: "",
    cp_teams_add_team_member_modal_field_role_error: ""
};
